import React from 'react';
import './pullQuote.scss';

const PullQuote = ({ quote }) => {
  return (
    <div className="pullQuote">
      <div className="pullQuote__text">
        <p className="pq">{quote}</p>
      </div>
    </div>
  );
};

export default PullQuote;
